import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { selectCurrentUser } from '@/store/modules/auth';

import TextField from '@material-ui/core/TextField';
import Button from '@/components/button';

import useStyles from '../styles';

import Grid from '@material-ui/core/Grid';

const StoresLayout = ({
  setstoreNameValue,
  storeNameValue,
  setActiveStep,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.addNewStore}
      spacing={10}
      justify="center"
    >
      <Grid
        container
        justify="flex-start"
        spacing={4}
        style={{ paddingTop: 30 }}
      >
        <Grid item>
          <div className={classes.findYourBussinessTitle}>
            {t('addStore.whats_your_store_name')}
          </div>
        </Grid>
        <Grid item>
          <div className={classes.descriptionSecondStep}>
            {t('addStore.whats_your_store_name_information')}
          </div>
        </Grid>
      </Grid>

      <Grid container justify="center" style={{ paddingTop: 50 }}>
        <Grid item xs={12}>
          <TextField
            id="standard-basic"
            style={{ width: '90%' }}
            defaultValue={storeNameValue}
            onChange={(e) => setstoreNameValue(e.target.value)}
          />
        </Grid>
      </Grid>

      <Grid
        container
        justify="center"
        xs={10}
        style={{ paddingTop: 50 }}
      >
        <Grid item>
          <div style={{ textAlign: 'center' }}>
            By continuing you agree to KRL{' '}
            <span className={classes.addStoreLink}>
              Terms of Service
            </span>{' '}
            and{' '}
            <span className={classes.addStoreLink}>
              Privacy Policy.
            </span>
          </div>
        </Grid>
      </Grid>
      <Grid container justify="center" style={{ padding: '20px 0' }}>
        <Button
          color="primary"
          className={classes.addStoreButton}
          variant="contained"
          onClick={() => setActiveStep(2)}
          disabled={storeNameValue === ''}
        >
          {t('addStore.add_store')}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  currentUser: selectCurrentUser(state),
});

export default connect(mapStateToProps)(StoresLayout);
